<canvas
	class="scene"
	#canvas
></canvas>
